module.exports = __webpack_public_path__ + "static/media/SuiteS01.ab704196.jpg";